import React from 'react';
import { Modal, Box, Typography, Button } from '@mui/material';

const DeleteSubscriptionPlan = ({
    deletePlan,
    onConfirm,
    onCancel,
    loading,
    modalType
}) => {
    return (
        <Modal
            open={modalType === 'deleteSubscriptionPlan'}
            onClose={onCancel}
            aria-labelledby="delete-subscription-plan-modal"
        >
            <Box
                sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: 400,
                    bgcolor: 'background.paper',
                    border: '2px solid #000',
                    boxShadow: 24,
                    p: 4,
                    borderRadius: 2
                }}
            >
                <Typography variant="h6" component="h2" gutterBottom>
                    Delete Subscription Plan
                </Typography>

                <Typography sx={{ mt: 2, mb: 3 }}>
                    Are you sure you want to delete the subscription plan "{deletePlan?.name}"?
                    This action cannot be undone.
                </Typography>

                <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end' }}>
                    <Button
                        variant="outlined"
                        onClick={onCancel}
                        disabled={loading}
                    >
                        Cancel
                    </Button>
                    <Button
                        variant="contained"
                        color="error"
                        onClick={onConfirm}
                        disabled={loading}
                    >
                        {loading ? 'Deleting...' : 'Delete'}
                    </Button>
                </Box>
            </Box>
        </Modal>
    );
};

export default DeleteSubscriptionPlan;
